module.exports = __webpack_public_path__ + "static/media/ic_site_name.f2df5fc0.svg";